import PrimaryText from "./PrimaryText";
import { Button } from "@chakra-ui/react";

const DataTableColumns = (screen, label, onRemindClick) => {
  const CustomCell = ({ value }) => {
    return (
      <div title={value || "No data available"}>
        {value
          ? value.length > 20
            ? `${value.slice(0, 20)}...`
            : value
          : "N/A"}
      </div>
    );
  };

  const columns = [
    {
      name: "TR-ID",
      selector: (row) => row.id,
      sortable: true,
      cell: (row) => <PrimaryText>{row.id}</PrimaryText>,
    },
    {
      name: "Patient Name",
      selector: (row) => row.patient_name,
      sortable: true,
      cell: (row) => <CustomCell value={row.patient_name} />,
    },
    {
      name: "Hospital",
      selector: (row) => row.hospital,
      sortable: true,
      cell: (row) => <CustomCell value={row.hospital} />,
    },
    ...(screen !== "Existing Patients"
      ? [
          {
            name: "Status",
            selector: (row) => row.status,
            sortable: true,
            cell: (row) => <CustomCell value={row.status} />,
          },
        ]
      : []),
  ];

  if (screen === "Pre-Intimation") {
    columns.push(
      {
        name: "Patient Moving From",
        selector: (row) => row.patient_moving_from,
        sortable: true,
        cell: (row) => <CustomCell value={row.patient_moving_from} />,
      },
      {
        name: "Arrival Within",
        selector: (row) => row.arrival_within,
        sortable: true,
        cell: (row) => <CustomCell value={row.arrival_within} />,
      }
    );
  } else if (screen === "Existing Patients") {
    columns.push(
      {
        name: "Health Concern",
        selector: (row) => row.health_concern,
        sortable: true,
        cell: (row) => <CustomCell value={row.health_concern} />,
      },
      {
        name: "IPS Opinion Status",
        selector: (row) => row.ips_opinion_status,
        sortable: true,
        cell: (row) => <CustomCell value={row.ips_opinion_status} />,
      },
      {
        name: "Visa Status",
        selector: (row) => row.visa_sub_status,
        sortable: true,
        cell: (row) => <CustomCell value={row.visa_sub_status} />,
      },
      {
        name: "Flight Ticket Status",
        selector: (row) => row.flight_ticket_status,
        sortable: true,
        cell: (row) => <CustomCell value={row.flight_ticket_status} />,
      },
      {
        name: "Pickup Details",
        selector: (row) => row.pickup_details_status,
        sortable: true,
        cell: (row) => <CustomCell value={row.pickup_details_status} />,
      },
      {
        name: "Pre Intimation Status",
        selector: (row) => row.preintmation_status,
        sortable: true,
        cell: (row) => <CustomCell value={row.preintmation_status} />,
      }
    );
  }

  // Add Remind button column if label is "Pending From Doctor"
  if (label === "Pending From Doctor") {
    columns.push({
      name: "Doctor Name",
      selector: (row) => row.doctor_name,
      sortable: true,
      cell: (row) => <CustomCell value={row.doctor_name} />,
    });
  }

  // Add Last Updated Date and Time at the end for all screens
  columns.push(
    {
      name: "Last Updated Date",
      selector: (row) => row.last_updated_date,
      sortable: true,
      cell: (row) => <CustomCell value={row.last_updated_date} />,
    },
    {
      name: "Last Updated Time",
      selector: (row) => row.last_updated_time,
      sortable: true,
      cell: (row) => <CustomCell value={row.last_updated_time} />,
    }
  );

  // Add Remind button column if label is "Pending From Doctor"
  if (label === "Pending From Doctor") {
    columns.push({
      name: "Action",
      cell: (row) => (
        <Button
          colorScheme="red"
          size="sm"
          onClick={() => onRemindClick(row.id)}
          disabled={row.doctor_reminder_count >= 3}
        >
          Remind
        </Button>
      ),
    });
  }

  return columns;
};

export default DataTableColumns;
